import { EVENT_NAMES } from "@scrile/api-provider/dist";
import { ErrorDTO } from "@scrile/api-provider/dist/lib/apiErrorHandler";
import emitter from "@/lib/emitter";

export interface ErrorHandler {
  comparator: (e: ErrorDTO) => boolean;
  onSuccessCB?: (e: ErrorDTO) => void;
}

export function handleRequestError(e: ErrorDTO[] | unknown, handlers: ErrorHandler[]) {
  if (Array.isArray(e)) {
    const errors = e.filter((e: ErrorDTO) => {
      let resolved = false;
      handlers.forEach(handler => {
        if (handler.comparator(e)) {
          handler.onSuccessCB && handler.onSuccessCB(e);
          resolved = true;
        }
      });

      if (resolved) {
        return false;
      } else {
        emitter.emit(EVENT_NAMES.REQUEST_STATUS, e);
        return true;
      }
    });
    if (errors.length > 0) throw e;
  } else throw e;
}
